import { ResumeDto, UpdateResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import debounce from "lodash.debounce";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const updateResume = async (data: UpdateResumeDto) => {
  const result: ResumeDto = {
    "id": "cm46m75o30001x34k8la34qiy",
    "title": "test",
    "slug": "testtest",
    "data": {
      "basics": {
        "url": {
          "href": "",
          "label": ""
        },
        "name": "yeah",
        "email": "317607692@qq.com",
        "phone": "",
        "picture": {
          "url": "",
          "size": 64,
          "effects": {
            "border": false,
            "hidden": false,
            "grayscale": false
          },
          "aspectRatio": 1,
          "borderRadius": 0
        },
        "headline": "大沙发上",
        "location": "",
        "customFields": []
      },
      "metadata": {
        "css": {
          "value": ".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
          "visible": false
        },
        "page": {
          "format": "a4",
          "margin": 18,
          "options": {
            "breakLine": true,
            "pageNumbers": true
          }
        },
        "notes": "",
        "theme": {
          "text": "#000000",
          "primary": "#dc2626",
          "background": "#ffffff"
        },
        "layout": [
          [
            [
              "profiles",
              "summary",
              "experience",
              "education",
              "projects",
              "volunteer",
              "references"
            ],
            [
              "skills",
              "interests",
              "certifications",
              "awards",
              "publications",
              "languages"
            ]
          ]
        ],
        "template": "azurill",
        "typography": {
          "font": {
            "size": 14,
            "family": "IBM Plex Serif",
            "subset": "latin",
            "variants": [
              "regular",
              "italic",
              "600"
            ]
          },
          "hideIcons": false,
          "lineHeight": 1.5,
          "underlineLinks": true
        }
      },
      "sections": {
        "awards": {
          "id": "awards",
          "name": "Awards",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "custom": {},
        "skills": {
          "id": "skills",
          "name": "Skills",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "summary": {
          "id": "summary",
          "name": "Summary",
          "columns": 1,
          "content": "<p></p>",
          "visible": true,
          "separateLinks": true
        },
        "profiles": {
          "id": "profiles",
          "name": "Profiles",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "projects": {
          "id": "projects",
          "name": "Projects",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "education": {
          "id": "education",
          "name": "Education",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "interests": {
          "id": "interests",
          "name": "Interests",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "languages": {
          "id": "languages",
          "name": "Languages",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "volunteer": {
          "id": "volunteer",
          "name": "Volunteering",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "experience": {
          "id": "experience",
          "name": "Experience",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "references": {
          "id": "references",
          "name": "References",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "publications": {
          "id": "publications",
          "name": "Publications",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        },
        "certifications": {
          "id": "certifications",
          "name": "Certifications",
          "items": [],
          "columns": 1,
          "visible": true,
          "separateLinks": true
        }
      }
    },
    "visibility": "private",
    "locked": false,
    "userId": "cm3zqv99i000010mzfz0c10yq",
    "createdAt": "2024-12-02T05:53:42.002Z",
    "updatedAt": "2024-12-03T02:21:06.026Z"
  };
  return result;
  const response = await axios.patch<ResumeDto, AxiosResponse<ResumeDto>, UpdateResumeDto>(
    `/resume/${data.id}`,
    data,
  );

  queryClient.setQueryData<ResumeDto>(["resume", { id: response.data.id }], response.data);

  queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
    if (!cache) return [response.data];
    return cache.map((resume) => {
      if (resume.id === response.data.id) return response.data;
      return resume;
    });
  });

  return response.data;
};

export const debouncedUpdateResume = debounce(updateResume, 500);

export const useUpdateResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: updateResumeFn,
  } = useMutation({
    mutationFn: updateResume,
  });

  return { updateResume: updateResumeFn, loading, error };
};
